// Utility for fetching listings from Spark API
export async function fetchListings({ agentId, token }) {
  try {
    // Set base URL based on environment
    let baseUrl = 'http://localhost:4000';
    
    if (import.meta.env.MODE === 'production' || import.meta.env.MODE === 'staging') {
      baseUrl = 'https://snippen.onrender.com';
    }
    
    const expandClause = "$expand=Media($filter=MediaCategory eq 'Photo'%3B$orderby=Order asc)";
    const url = `${baseUrl}/api/listings?agentId=${agentId}&${expandClause}`;
    // console.log('Fetching from URL:', url); // Removed for privacy
    
    const res = await fetch(url, {
      method: 'GET',
      headers: {
        'Accept': 'application/json',
        'Authorization': `Bearer ${token}`,
        'X-Agent-ID': agentId,
      },
      // Only include credentials in production
      credentials: import.meta.env.MODE === 'production' ? 'include' : 'same-origin'
    });
    
    // Removed debug log for production
    
    if (!res.ok) {
      const errorData = await res.json().catch(() => ({}));
      console.error('API Error:', errorData);
      throw new Error(errorData.error || `HTTP error! status: ${res.status}`);
    }
    
    const data = await res.json();
    // Use the backend-mapped fields directly
    return data.value || [];
  } catch (error) {
    console.error('Error in fetchListings:', {
      message: error.message,
      name: error.name,
      stack: error.stack,
      agentId,
      tokenPresent: !!token,
      env: import.meta.env.MODE,
    });
    throw error; // Re-throw to be handled by the caller
  }
}

// Helper for agent role (kept for possible future use)
export function getAgentRole(listing, agentId) {
  if (listing.ListAgentKey === agentId || listing.CoListAgentKey === agentId) return 'Listing Agent';
  if (listing.BuyerAgentKey === agentId || listing.CoBuyerAgentKey === agentId) return 'Buyside Agent';
  return '';
}
